export function makeFill(fill) {
    if (fill === void 0) { fill = false; }
    if (fill === true) {
        return 'currentColor';
    }
    return undefined;
}
